import { useQuery } from '@tanstack/react-query';
import { homePatientApi } from './api';

export const useGetHomePatient = ({ enabled = true } = {}) => {
  const queryResult = useQuery({
    queryKey: ['get-home-patient'],
    queryFn: () => homePatientApi.getHomePatient(),
    enabled,
  });
  return queryResult;
};

// Per the sessions contract: no server-driven backoff, no pollAfterSeconds — status is the
// whole polling contract. Keep polling only while STARTED; stop on anything else
// (NOT_STARTED / PAUSED / COMPLETED / DISCARDED all mean "nothing will change on its own").
// Jitter avoids many clients polling in lockstep.
const POLL_INTERVAL_MS = 30_000;
const POLL_JITTER_MS = 2_000;

export const useGetSession = (id, { enabled = true } = {}) => {
  const queryResult = useQuery({
    queryKey: ['get-session', id],
    queryFn: () => homePatientApi.getSession(id),
    enabled: enabled && !!id,
    refetchInterval: query => {
      const status = query.state.data?.data?.status;
      if (status !== 'STARTED') {
        return false;
      }
      return POLL_INTERVAL_MS + Math.random() * POLL_JITTER_MS;
    },
  });
  return queryResult;
};
